<app-loader *ngIf="isDisabled"></app-loader>
<form name="EmpSummaryForm" (ngSubmit)="Validate(EmpSummaryForm)" #EmpSummaryForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Send To {{this.Type == 'I'?'Internal' : 'Client'}} SPOC for <span
                    class="fw-bold">({{this.SiteName}})</span></label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="summarydata"
                        class="customeDatatable table table-bordered" name="summarydata"
                        style="font-size: xx-small !important">
                    </table>
                </div>
            </div>
            <div class="row my-3">
                <div class="col-md-2">
                    <label for="WebCheckInOut" class="form-label text-label-dark">Report Formats :</label>
                </div>
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="MonthlySummary"
                                    name="MonthlySummary" [(ngModel)]="Filter.IsMonthlySummary">
                                <label class="label" for="MonthlySummary">Monthly
                                    Summary</label>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="BillingSummary"
                                    name="BillingSummary" [(ngModel)]="Filter.IsBillingSummary">
                                <label class="label" for="BillingSummary">Billing
                                    Summary</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <label for="MailId" class="text-label-dark">Extra MailId <small class="text-muted">(multiple mail id
                            add comma seprated)</small> </label>
                    <input type="text" class="form-control" id="MailId" name="MailId" [(ngModel)]="Filter.MailId"
                        #MailId="ngModel">
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer p-2">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button type="button" class="btn  btn-sm btn-outline-primary me-1" (click)="close()"
                    [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>

                <button type="submit" class="btn btn-sm btn-primary" [disabled]="isDisabled"><i class="bi bi-send-check"
                        *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Send':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>